import React from 'react'
import NavLink from '../Routes/NavLink'
import moment from 'moment'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

import { notifications } from '../../core/controllers/Notifications'

export default class NotificationsTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            list: []
        };
    }

    componentDidMount() {
        var limit = this.props.limit ? this.props.limit : 0;
        notifications.getNotifications(this, limit);
    }

    componentDidUpdate() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    simpleFormatSubmittedDate(cell, row) {
        return moment(cell).format('MMM Do YYYY');
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    render(){
        const notificationsList = this.state.list;
        return (
            <div class="content">
            {notificationsList.length > 0 ? (
                <BootstrapTable data={notificationsList} version='4' striped search pagination hover>
                    <TableHeaderColumn width="50" dataField='id' dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                    <TableHeaderColumn dataField='title' dataSort={ true }>Title</TableHeaderColumn>
                    <TableHeaderColumn dataField='message' dataSort={ true }>Message</TableHeaderColumn>
                    <TableHeaderColumn dataField='created_at' dataFormat={this.simpleFormatSubmittedDate} dataSort={ true }>Created</TableHeaderColumn>
                </BootstrapTable>
            ) : (
                <p>No recent activity.</p>
            )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Notifications/NotificationsTable.jsx